import {Component, OnDestroy, OnInit} from '@angular/core';
import {AlertService, GroupService, UserService} from "../services";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { Router, ActivatedRoute } from '@angular/router';
import {first, takeUntil} from 'rxjs/operators';
import {CustomerSourceService} from "../services/customerSource.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {ComponentTitleService} from "../services/componentTitle.service";
import {User} from "../models";
import {CardService} from "../services/card.service";
import {Subject} from "rxjs";

@Component({
    templateUrl: './addCard.component.html',
    styleUrls: ['./addCard.component.scss']
})

export class AddCardComponent implements OnDestroy, OnInit {
    form: FormGroup;
    user: User;
    id: string;
    submitted = false;
    loading = false;
    cardExists = true;
    cardNumber: string = '';
    checkingCardNumber = false;
    private _unsubscribeAll: Subject<any>;

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private userService: UserService,
        private alertService: AlertService,
        private customerSourceService: CustomerSourceService,
        private translationLoader: FuseTranslationLoaderService,
        private componentTitleService: ComponentTitleService,
        private cardService: CardService
    ) {
        this._unsubscribeAll = new Subject();
        this.translationLoader.loadTranslations(polish, english);

        componentTitleService.clearTitle();
        componentTitleService.addPart('Customers');
    }

    ngOnInit() {
        this.id = this.route.snapshot.params['id'];
        this.user = this.route.snapshot.data.userData;

        this.form = this.formBuilder.group({
            cardNumber: ['', Validators.required],
            userId: ['', Validators.required],
        });

        this.f.userId.setValue(this.id);
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    get f() { return this.form.controls; }

    onSubmit() {
        this.submitted = true;

        // reset alerts on submit
        this.alertService.clear();

        // stop here if form is invalid
        if (this.form.invalid) {
            return;
        }

        this.loading = true;

        this.createCart();
    }

    verifyCardNumber(event: any) {
        this.unsubscribe();
        this.cardNumber = event.target.value;
        this.checkingCardNumber = true;
        this.cardExists = true;
        this.cardService.getByNumber(event.target.value).pipe(takeUntil(this._unsubscribeAll))
            .subscribe(data => {
                this.cardExists = true;
                this.checkingCardNumber = false;
            }, error => {
                this.cardExists = false;
                this.checkingCardNumber = false;
            });
    }

    private createCart() {
        let formData = this.form.value;
        this.cardService.addCart(formData.userId, formData.cardNumber)
            .pipe(first())
            .subscribe(
                data => {
                    this.alertService.success('Created successful', { keepAfterRouteChange: true });
                    this.router.navigate(['..', { relativeTo: this.route }]);
                },
                error => {
                    this.alertService.error(error);
                    this.loading = false;
                });
    }

    private unsubscribe(): void {
        this._unsubscribeAll.next();
    }
}
